import { useState, useEffect } from 'react';
import brandingService from '../services/brandingService';

export const useBranding = () => {
    const [branding, setBranding] = useState({
        site_name: 'Ennovatrade',
        logo_url: '/logo.png',
        hero_title: 'Tradez. Investissez. Faites croître votre équipe.',
        hero_subtitle: 'La première plateforme crypto combinant trading professionnel, investissement passif et MLM multi-niveaux en un seul écosystème.',
        footer_about: 'NOVA Platform est une solution de trading et d\'investissement institutionnelle conçue pour la nouvelle génération de financiers.',
        copyright: '© 2026 NOVA Platform. Tous droits réservés.',
        support_email: 'assist@ennovatrade.global',
        office_address: 'Financial Tower, Dubai, UAE',
        social_links: {
            twitter: '#',
            telegram: '#',
            discord: '#',
            instagram: '#'
        },
        footer_sections: [],
        // Page content
        page_terms_content: '',
        page_privacy_content: '',
        page_aml_content: '',
        page_risk_content: '',
        page_about_content: '',
        page_contact_content: '',
        page_security_content: '',
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBranding = async () => {
            try {
                const response = await brandingService.getPublicBranding();
                if (response.success) {
                    setBranding(prev => ({ ...prev, ...response.data }));
                }
            } catch (error) {
                console.error('Error fetching branding:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchBranding();
    }, []);

    return { branding, loading };
};
